var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VBtn',{attrs:{"fab":"","small":"","depressed":"","color":"white"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('VIcon',{attrs:{"color":"gray","small":""}},[_vm._v(" mdi-content-copy ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }